(function () {
    'use strict';

    angular.module('app.stockItems')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'stockItems',
                config: {
                    url: '/stockItems',
                    title: 'Envanter Listesi',
                    abstract: true,
                    templateUrl: 'app/stockItems/stockItems.html'
                }
            },
            {
                state: 'stockItems.list',
                config: {
                    templateUrl: 'app/stockItems/stockItems.list.html',
                    controller: 'StockItemsListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Envanter Listesi',
                    settings: {
                        nav: 33,
                        name: 'stockItems.list',
                        topName: 'sales',
                        content: 'Envanter Listesi',
                        resource: 'menu.stockItems.list'
                    }
                }
            },
            {
                state: 'stockItems.payment',
                config: {
                    templateUrl: 'app/stockItems/stockItems.payment.html',
                    controller: 'StockItemsPaymentController',
                    controllerAs: 'vm',
                    url: '/payment',
                    title: 'Envanter Ödeme Listesi',
                    settings: {
                        nav: 33,
                        name: 'stockItems.payment',
                        topName: 'sales',
                        content: 'Envanter Ödeme Listesi',
                        resource: 'menu.stockItems.payment'
                    }
                }
            },
            {
                state: 'stockItems.add',
                config: {
                    templateUrl: 'app/stockItems/stockItems.add.html',
                    controller: 'StockItemsAddController',
                    controllerAs: 'vm',
                    url: '/add',
                    title: 'Envanter Ekle'
                }
            },
            {
                state: 'stockItems.edit',
                config: {
                    templateUrl: 'app/stockItems/stockItems.edit.html',
                    controller: 'StockItemsEditController',
                    controllerAs: 'vm',
                    url: '/edit/:StockItemId',
                    title: 'Envanter Düzenle'
                }
            },
            {
                state: 'stockItems.detail',
                config: {
                    templateUrl: 'app/stockItems/stockItems.detail.html',
                    controller: 'StockItemsDetailController',
                    controllerAs: 'vm',
                    url: '/detail/:StockItemId',
                    title: 'Envanter Detayı'
                }
            }
        ];
    }
})();